/** Pick the single ProjectSettings row widgets and settings UI should use. */
export function pickCanonicalProjectSettings<
  T extends { id: string; ctaClusters?: Array<unknown> | null },
>(settings: T[] | null | undefined): T | null {
  if (!settings?.length) return null;
  if (settings.length === 1) return settings[0] ?? null;

  // Newest row wins — do NOT prefer rows that still have CTAs (stale duplicate rows
  // would resurrect deleted handoff actions after the canonical row was cleared).
  const sorted = [...settings].sort((a, b) => b.id.localeCompare(a.id));
  return sorted[0] ?? null;
}

export function normalizeProjectSettingsArray<
  T extends { id: string; ctaClusters?: Array<unknown> | null },
>(settings: T[] | null | undefined): T[] {
  const canonical = pickCanonicalProjectSettings(settings);
  return canonical ? [canonical] : [];
}
